

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { PatientRegistration } from '../patient-services/patient-registration';


export interface IpServiceDetParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface IpServiceDet {
    id?: any;
    iPId?: any;
    regId: any;
    
    createdDate: any;
    createdBy: string;
    wardId: any;
    bedId: any;
    serviceDate: any;
    serviceTime:any;
    physicianId: any;
    serviceId: any;
    quantity: any;
    rate: any;
    amount: any;
    iPBillDone:string;
    iPBillId: any;
    iPCancelFlag: string;
    labDoneFlag: string;
    labRegisterId: any;
    discountType:any;
    discountPercentage:any;
    discountAmount:any;
    netAmount:any;

    tenantId: any;
    branchId: any;
    labSentStatus?:string;
    emergencyStatus?:string;
    serviceList?:any;
	labworkorderdetid?:any;
    labworkordermstid?:any;
    serviceFrom:string;
   // patientRegistration?: PatientRegistration;
    radSentStatus:string;

    parameters?: IpServiceDetParameter[];
    links?: any;
    approvalStatus?:any;
}

export abstract class IpServiceDetData {
    //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
    abstract list(url: string): Observable<IpServiceDet[]>;
    abstract deleteByIds(url: string, ids: string[]): Observable<any>;
    abstract create(url: string, data: IpServiceDet): Observable<IpServiceDet[]>;
    abstract update(url: string, data: IpServiceDet): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract createRoomRent(url: string, data: any): Observable<any>;
    abstract updateRoomRent(url: string, data: any): Observable<any>;
	abstract searchByType(url: string): Observable<any>;
    abstract postmeth(url: string, data: any): Observable<any>;
    abstract searchByWardPrice(url: string,data:any): Observable<any>;
}
